<template>
  <div>
    <v-app-bar
      app
      :color="navColor"
      dense
      flat
      justify-center
      v-bind="{ ...$attrs, ...$props }"
    >
      <v-btn
        :class="['home-btn mr-1', getIsBakeSale ? 'bar-btn' : '']"
        to="/"
        text
        small
        tile
      >
        {{ getShopTitle }}
      </v-btn>
      <v-spacer />

      <transition name="fade" mode="out-in">
        <v-btn
          v-if="
            !_includes(['xs', 'sm'], $mq) &&
              _includes(
                ['/', '/login', '/signup', '/owner/login', '/about', '/help'],
                $route.path
              ) &&
              !canMerchant &&
              !getIsShopDead
          "
          :to="canCustomer ? '/order' : '/menu'"
          class="mr-2"
          color="white"
          outline-color="black"
          small
          depressed
        >
          {{ canCustomer ? 'Order Now' : 'VIEW OUR MENU' }}
        </v-btn>
        <v-btn
          v-else-if="
            !_includes(['xs', 'sm'], $mq) &&
              $route.path === '/menu' &&
              !canMerchant
          "
          @click="startOrderBtnClick"
          class="mr-2"
          color="deep-orange white--text"
          small
          depressed
        >
          Start an Order
        </v-btn>
      </transition>
      <template v-if="getAuthUserName && !canMerchant">
        <v-btn text :to="{ name: customerDashRoute }" small plain>
          {{ getAuthUserName }}
        </v-btn>
      </template>
      <AdminAccountBtnDropdown v-else-if="getAuthUserName && canMerchant" />

      <v-app-bar-nav-icon
        v-if="!getIsShopDead"
        @click="isDrawerVisible = true"
      />
    </v-app-bar>
    <NavDrawer
      v-if="!getIsShopDead"
      :show="isDrawerVisible"
      @toggle="isDrawerVisible = $event"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _includes from 'lodash/includes'
import NavDrawer from '@/components/NavDrawer'
import AdminAccountBtnDropdown from '@/components/AdminAccountBtnDropdown'
import RouteNames from '@/constants/RouteNames'

export default {
  name: 'NavBar',
  components: { NavDrawer, AdminAccountBtnDropdown },
  data() {
    return {
      isDrawerVisible: false,
      customerDashRoute: RouteNames.Customer.ORDERS_INDEX,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopTitle', 'getIsShopDead', 'getIsBakeSale']),
    ...mapGetters('auth', ['getAuthUserName', 'canCustomer', 'canMerchant']),
    navColor() {
      return this.getIsBakeSale ? 'red lighten-4' : 'amber lighten-3'
    },
  },
  methods: {
    startOrderBtnClick() {
      if (this.$gtag) {
        this.$gtag.event('start_order_btn_nav')
      }
      this.$router.push({ name: RouteNames.Guest.NEW_ORDER })
    }, // startOrderBtnClick
    _includes,
  },
}
</script>

<style lang="scss">
.home-btn.v-btn {
  justify-content: start;
  min-width: 10px;
  max-width: calc(100% - 80px);
  overflow: hidden;
  .v-btn__content {
    width: 100%;
    white-space: initial;
    // text-overflow: ellipsis;
  }
}
.v-btn.home-btn:before {
  background: transparent;
}
.v-btn.home-btn {
  :hover:before {
    background: #ffb300;
    opacity: 0.3;
  }
  &.bar-btn:hover:before {
    background: #00fcff;
    opacity: 0.4;
  }
}
</style>
